import React from "react";
import { ArrowRight, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PensacolasClimateExperts() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="4800" id="nexo-tech-engineering" ref={sectionRef} className="relative w-full overflow-hidden bg-background py-20 lg:py-32 dark">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.05]">
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/florida_coastline_map.png)] bg-cover bg-center bg-no-repeat grayscale invert" />
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-8 lg:items-center">
          {}
          <div className={`flex flex-col gap-8 lg:col-span-7 transition-all duration-1000 ease-out ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-10 opacity-0"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 rounded-md border border-primary/30 bg-primary/5 px-4 py-1.5 text-xs font-mono uppercase tracking-widest text-primary w-fit">
                <MapPin className="h-4 w-4" />
                <span>Profesionální HVAC servis & inženýrství</span>
              </div>
              
              <h1 className="text-6xl font-extrabold tracking-tighter sm:text-8xl lg:text-9xl xl:text-[120px] leading-[0.9]">
                <span className="block text-foreground">NEXO</span>
                <span className="block bg-gradient-to-r from-primary via-primary to-secondary bg-clip-text text-transparent">
                  TECH
                </span>
              </h1>
            </div>

            <p className="max-w-2xl text-lg text-muted-foreground sm:text-xl leading-relaxed font-sans">
              Instalace, servis a diagnostika klimatizací a tepelných čerpadel pro domácnosti, 
              firmy i průmysl. Navrženo pro preciznost a dlouhodobou spolehlivost 
              v jakémkoli prostředí.
            </p>

            <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
              <Button asChild size="lg" className="h-14 px-8 text-lg font-bold rounded-md bg-primary text-primary-foreground shadow-[0_0_25px_rgba(200,80,50,0.4)] transition-all hover:scale-105 hover:shadow-primary/60">
                <Link to="/ContactPage">
                  Získat nabídku
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg font-bold rounded-md border-2 border-secondary text-secondary hover:bg-secondary/10 hover:text-secondary">
                <Link to="/ContactPage">
                  <Phone className="mr-2 h-5 w-5" />
                  Žádost o servis
                </Link>
              </Button>
            </div>

            <div className="mt-4 flex items-center gap-6 text-xs font-mono uppercase tracking-wider text-muted-foreground">
              <div className="flex items-center gap-2">
                <div className="h-2 w-2 rounded-full bg-primary" />
                Průmyslová preciznost
              </div>
              <div className="flex items-center gap-2">
                <div className="h-2 w-2 rounded-full bg-secondary" />
                Inženýrská dokonalost
              </div>
            </div>
          </div>

          {}
          <div className={`relative lg:col-span-5 lg:h-full min-h-[400px] lg:min-h-[600px] flex items-center justify-center transition-all duration-1000 delay-300 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
            {}
            <div className="absolute inset-0 lg:inset-x-4 lg:inset-y-12 overflow-hidden rounded-xl bg-card border border-border">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/pensacola_sunset_soft_focus.png" alt="Moderní HVAC infrastruktura" className="h-full w-full object-cover opacity-40 blur-[1px] scale-110 grayscale" />
              <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />
            </div>

            {}
            <div className="relative z-10 mt-12 lg:mt-0 lg:absolute lg:-bottom-8 lg:-left-8 lg:right-8">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582043/img/technician_smart_thermostat.png" alt="Inženýrské vybavení NEXO TECH" className="mx-auto w-full max-w-md drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)] lg:max-w-full object-contain" />
              
              {}
              <div className="absolute bottom-8 right-4 lg:-right-4 animate-bounce duration-[3000ms]">
                <div className="flex items-center gap-3 rounded-md bg-card/90 p-4 shadow-2xl backdrop-blur-md border border-border">
                  <div className="flex h-12 w-12 items-center justify-center rounded-md bg-primary/20 text-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
                      <path d="M12 2v20" />
                      <path d="M2 12h20" />
                      <path d="m4.93 4.93 14.14 14.14" />
                      <path d="m19.07 4.93-14.14 14.14" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-[10px] font-mono uppercase tracking-tighter text-muted-foreground">Efektivita systému</p>
                    <p className="text-lg font-bold text-foreground">Optimalizováno</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}